module.exports = __webpack_public_path__ + "static/media/navigate-d8.862cfe80.svg";